import {apiCore} from "./apiCore";

export const installApplicationApi = apiCore
    .injectEndpoints({
        endpoints: (build) => ({
            sendAppLinkOrSms: build.mutation({
                query: (arg) => ({
                    url: '/markets/',
                    method: "POST",
                    body: {
                        type: arg?.type,
                        market: arg?.market
                    }
                })
            })
        })
    })

export const {useSendAppLinkOrSmsMutation} = installApplicationApi
